import Script from 'next/script';
export default function MarketingScripts({
  nonce
}) {
  return <>
			<Script id="fb-pixel" nonce={nonce} strategy="afterInteractive" dangerouslySetInnerHTML={{
      __html: `
						!function(f,b,e,v,n,t,s)
						{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
						n.callMethod.apply(n,arguments):n.queue.push(arguments)};
						if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
						n.queue=[];t=b.createElement(e);t.async=!0;
						t.src=v;s=b.getElementsByTagName(e)[0];
						s.parentNode.insertBefore(t,s)}(window, document,'script',
						'https://connect.facebook.net/en_US/fbevents.js');
						fbq('init', '330769881591094');
						fbq('track', 'PageView');
					`
    }} data-sentry-element="Script" data-sentry-source-file="MarketingScripts.jsx" />
			<Script id="gtag-conversion-script" nonce={nonce} dangerouslySetInnerHTML={{
      __html: `
      function gtag_report_conversion(url) {
        var callback = function () {
          if (typeof url != 'undefined') {
            // window.location = url;
          }
        };
        gtag('event', 'conversion', {
          send_to: 'AW-939226597/Lh90CI67x9sCEOXr7b8D',
          event_callback: callback,
        });
        return false;
      }`
    }} data-sentry-element="Script" data-sentry-source-file="MarketingScripts.jsx" />

			<noscript dangerouslySetInnerHTML={{
      __html: `
						<img height="1" width="1"
						src="https://www.facebook.com/tr?id=330769881591094&ev=PageView&noscript=1"/>
					`
    }} />
		</>;
}